<template>
  <div>
    <div v-if="ui.cargando" class="text-center py-10">
      <div class="spinner spinner-primary"></div>
    </div>
    <edit-ficha-provincia v-else-if="esProvincia" :es-version-app="esVersionApp" />
    <edit-ficha-lima v-else-if="tipoResuelto" :es-version-app="esVersionApp" />
    <div v-else class="alert alert-custom alert-light-danger">
      <div class="alert-text">No se pudo determinar el tipo de ficha de esta mesa.</div>
    </div>
  </div>
</template>

<script>
/**
 * Entrada común 2026-ERM. Si la mesa ya tiene FichaTipo, monta Lima o Provincia.
 * Si aún no hay tipo, se abre Lima (comportamiento previo de los listados).
 * Las URLs /2026-erm-lima y /2026-erm-provincia siguen siendo explícitas.
 */
const CODIGO_PROVINCIA = "ERM_PROV_2026";

export default {
  name: "EditFicha2026Erm",
  components: {
    EditFichaLima: () => import("@/view/sheet/2026-ERM/EditFichaLima"),
    EditFichaProvincia: () => import("@/view/sheet/2026-ERM/EditFichaProvincia"),
  },
  props: {
    esVersionApp: { type: Boolean, default: false },
  },
  data() {
    return {
      ui: { cargando: true },
      esProvincia: false,
      tipoResuelto: false,
    };
  },
  mounted() {
    this.resolverTipo();
  },
  methods: {
    resolverTipo() {
      const p = this.$route.params;
      this.$http
        .post(this.apiRoute("Sheet", "GetFichaLocalVotacionMesa"), {
          localVotacionId: Number(p.localVotacionId || 0),
          mesaVotacionId: Number(p.mesaVotacionId),
          procesoElectoralId: Number(p.procesoElectoralId),
          turno: p.turno ? Number(p.turno) : null,
        })
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) {
            this.ui.cargando = false;
            return;
          }
          debugger;
          const codigo = ((response.body.data || {}).fichaTipoCodigo || "").toUpperCase();
          this.esProvincia = codigo === CODIGO_PROVINCIA;
          this.tipoResuelto = true;
          this.ui.cargando = false;
        }, function (error) {
          this.ui.cargando = false;
          this.mostrarMensajeExcepcionVueResource(error);
        });
    },
  },
};
</script>
